






























































import {
  Component,
  Vue,
  Provide,
  Watch,
  Prop,
  Emit,
} from 'vue-property-decorator';
// Model, Inject, Emit, Prop, Watch
// import { Mutation, State, Action, Getter } from 'vuex-class';

@Component
export default class NavBar extends Vue {
  // private height: any = calc(100% - ) activeBg
  @Prop({ type: Boolean, required: false }) private leftArrow!: boolean;
  @Prop({ type: String, default: '', required: false }) private title!: string;
  @Prop({ type: Array, required: false }) private rightBtns!: object[];
  @Prop({ type: String, required: false }) private leftIcon!: string;
  @Prop({ type: Array, required: false }) private titles!: any[];

  //
  @Emit('backCall')
  private backCall() {
    return true;
  }
  // 导航左侧功能按键
  @Emit('leftIcon_call')
  private callFun() {
    return true;
  }
  private created() {
    if (this.titles && this.titles[0]) {
      this.titles[0].checked = true;
    }
  }

  // 标题
  // @Emit('titleCallBack')
  private selected(item: any, index: number) {
    this.titles.forEach((element: any) => {
      element.checked = false;
    });
    item.checked = true;
    this.titles.splice(index, 1, item);
    // return item;
  }
}
